var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"user-config-layer"}},[_vm._v(" 安全配置 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }